// Auth Store
import { getField } from 'vuex-map-fields'

const state = {
  pending: false,
  isAuthenticated: false,
}

const getters = {
  getField,
  isLoggedIn: (state) => state.isAuthenticated && !state.pending
}

const actions = {
  getAuthStatus({ commit }) {
    return new Promise(resolve => {
      commit('SET_PENDING', true)

      this.api.items.getItem('auth.is-authenticated').then(({ data }) => {
        commit('SET_AUTH_STATUS', data.isAuthenticated)
        commit('SET_PENDING', false)
        resolve()
      })
    })
  },
}

const mutations = {
  SET_AUTH_STATUS: (state, payload) => {
    state.isAuthenticated = payload
  },
  SET_PENDING: (state, payload) => {
    state.pending = payload
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
